import { useEffect, useState } from 'react';
import { useLazyGetCoCustomerTimeSeriesQuery } from 'src/services/coCustomerAnalyticsService';
import { TimeSeriesRequestParams } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

/**
 * Fetches the co-customer analytics time series for the given request params,
 * clearing the response on a 404 (no data for the selected range).
 */
export const useCoCustomerTimeSeries = (
  requestParams: TimeSeriesRequestParams,
  enabled: boolean,
) => {
  const [fetchTimeSeriesQuery, { data: timeSeriesData, isFetching, isError, error }] =
    useLazyGetCoCustomerTimeSeriesQuery() as any;
  const [timeSeriesResponse, setTimeSeriesResponse] = useState([]);

  useEffect(() => {
    if (enabled && requestParams) {
      fetchTimeSeriesQuery(requestParams);
    }
  }, [enabled, requestParams]);

  useEffect(() => {
    if (isError && error?.status === 404) {
      setTimeSeriesResponse([]);
    }
  }, [isError, error]);

  useEffect(() => {
    setTimeSeriesResponse(timeSeriesData && timeSeriesData.length ? timeSeriesData : []);
  }, [timeSeriesData]);

  return { timeSeriesResponse, isFetching };
};
